export default {
  SET_CONSULT({ commit }, payload) {
    commit('SET_CONSULT', payload);
  },

  SET_DOCUMENTS_CONSULTED({ commit }, payload) {
    commit('SET_DOCUMENTS_CONSULTED', payload);
  },

  SET_AGENDA({ commit }, payload) {
    commit('SET_AGENDA', payload);
  },
};
